import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import {
  Monthly,
  RewardHighlightedHeading,
  Weekly,
  Yearly,
} from "../../../utils/Constant";
import CustomMarquee from "../../../CommonElements/Marquee/Marquee";
import { useEffect, useState } from "react";
import { NewsService } from "../../../Service/NewsEvents/NewsService";

// import { Btn, H6, H5, Image } from "../../../AbstractElements";
// import Marquee from "react-fast-marquee";

// Step 1: Define a type for a single news item.
interface NewsItem {
  NewsId: number;
  NewsHeading: string;
  NewsIconImage: string;
  NewsDetail: string;
  NewsDescription: string;
  EntryDate: string;
}
const Notifications = () => {
  const { fetchNews } = NewsService();
  const [news, setNews] = useState<NewsItem[]>([]);

  useEffect(() => {
    const loadNews = async () => {
      // The fetchNews function should be typed to return Promise<NewsItem[] | any>
      const data = await fetchNews();

      // Explicitly check if data is an array before setting state.
      // This is good practice.
      if (Array.isArray(data)) {
        setNews(data);
      }
    };
    loadNews();
  }, []); // Add fetchNews to the dependency array

  const UserName = localStorage.getItem("MemberName");
  return (
    <Col sm="12" md="4" xl="4" className="order-md-4 order-5">
      <Card className="notification-card text-center boxshadow">
        <CardHeaderCommon
          headClass="cardHeaderCustom"
          title={RewardHighlightedHeading}
          firstItem={Weekly}
          secondItem={Monthly}
          thirdItem={Yearly}
        />
        <CardBody className="text-center px-2 px-md-3">
          <CustomMarquee direction="up" speed={30}>
            {news.length > 0 ? (
              news.slice(0, 5).map((item) => (
                <div key={item.NewsId} className="mb-4">
                  <h5 className="my-3">{item.NewsHeading}</h5>
                  <p>{item.NewsDetail}</p>
                </div>
              ))
            ) : (
              <div className="text-muted my-3">
                <h6>No notifications available</h6>
              </div>
            )}
          </CustomMarquee>

          {/* <div style={{ height: "200px", width: "100%", overflow: "hidden" }}>
            <Marquee
              gradient={false}
              speed={50}
              pauseOnHover={true}
              style={{
                height: "200px",
                transform: "rotate(-90deg)",
                transformOrigin: "center",
              }}
            >
              <div style={{ transform: "rotate(90deg)" }}>
                <h5>Hi, {UserName}</h5>
                <h6 className="mt-3">
                  Nothing to see here. We'll notify you when something comes up!
                </h6>
                <p>
                  सुकन्या स्वास्तिक केयर बायोडिग्रेडेबल सैनिटरी पैड्स और
                  जागरूकता अभियानों के ज़रिए महिलाओं के स्वास्थ्य व सम्मान की
                  दिशा में अनूठी पहल कर रहा है।
                </p>
              </div>
            </Marquee>
          </div> */}

          {/* {notificationsData.map((item, i) => (
            <div className={`d-flex ${item.class} gap-3`} key={i}>
              <div className="flex-shrink-0">
                {item.image && <Image className="img-40 b-r-15" src={dynamicImage(`avatar/${item.image}`)} alt="Use1" />}
                {item.name && <span className={`bg-${item.color}`}>{item.name}</span>}
              </div>
              <div className="flex-grow-1">
                <Link to={Href}>
                  <H6>{item.notification}</H6>
                </Link>
                <span>{item.time}</span>
                {item.buttons && <div className="d-flex gap-2 p-0 mt-2">
                  <Btn color="outline-dark">{Decline}</Btn>
                  <Btn color="primary">{Accept}</Btn>
                </div>}
              </div>
              {item.dot &&
                <div className="circle-dot-primary">
                  <span />
                </div>
              }
            </div>
          ))} */}
        </CardBody>
      </Card>
    </Col>
  );
};

export default Notifications;
